
export const CHART_X_AXIS_PADDING_LEFT = 0;
export const CHART_X_AXIS_PADDING_RIGHT = 0;
export const BRUSH_POSITION_START = 'start';
export const BRUSH_POSITION_END = 'end';
export const BRUSH_INITIAL_DATA_LENGTH = 8;


export const getBrushProps = (position, brushDataLength, dataLength) => {
    let brushProps = {};
    switch (position) {
        case BRUSH_POSITION_START:
            brushProps.startIndex = 0;
            brushProps.endIndex = dataLength >= brushDataLength ? brushDataLength - 1 : dataLength - 1;
            break;
        case BRUSH_POSITION_END:
            brushProps.startIndex =
                dataLength >= brushDataLength ? dataLength - brushDataLength : 0;
            brushProps.endIndex = dataLength - 1;
            break;
    }
    return brushProps;
};
